import { api, ApiError } from './api';
import { purchaseAppleSubscription, restoreApplePurchases, iosIapAvailable } from './appleIap';
import { openExternalUrl } from './openExternalUrl';
import type { AppleIapPlan } from './appleIapProducts';

export function checkoutErrText(e: unknown): string {
  if (e instanceof ApiError && e.body) {
    try {
      const j = JSON.parse(e.body) as { error?: string };
      if (j?.error) return j.error;
    } catch {
      /* ignore */
    }
  }
  return e instanceof Error ? e.message : 'Something went wrong.';
}

/** Web Stripe checkout or native App Store subscription purchase. */
export async function purchaseSubscriptionPlan(
  plan: AppleIapPlan,
  refresh?: () => Promise<void>,
): Promise<void> {
  if (iosIapAvailable()) {
    await purchaseAppleSubscription(plan);
    if (refresh) await refresh();
    return;
  }

  const { url } = await api<{ url: string }>('/api/stripe/create-checkout-session', {
    method: 'POST',
    body: JSON.stringify({ plan }),
  });
  if (!url) throw new Error('Checkout could not start.');
  await openExternalUrl(url);
}

export async function restoreSubscriptionPurchases(refresh?: () => Promise<void>): Promise<boolean> {
  if (!iosIapAvailable()) return false;
  const result = await restoreApplePurchases();
  if (result && refresh) await refresh();
  return Boolean(result);
}
